import { ARIA_LIVE_MESSAGE_ANNOUNCE_TIME_IN_MS } from '@frontstoreRwd/modules/aria_live_messages/aria_live_messages_constants';

export default {
    initialize: function () {
        const $ariaLiveAssertiveRegion = document.querySelector<HTMLElement>('#aria-live-assertive');
        const $ariaLiveMessagesContainers = [...document.querySelectorAll<HTMLElement>('[live-messages]')];

        if ($ariaLiveMessagesContainers.length === 0 || !$ariaLiveAssertiveRegion) return;

        const message = $ariaLiveMessagesContainers.reduce<string>((totalMessage, $ariaLiveMessagesContainer) => {
            return totalMessage += this.extractTextFromAriaLiveMessagesContainer($ariaLiveMessagesContainer);
        }, '');

        setTimeout(() => {
            $ariaLiveAssertiveRegion.innerText = message;
        }, ARIA_LIVE_MESSAGE_ANNOUNCE_TIME_IN_MS);
    },

    extractTextFromAriaLiveMessagesContainer($ariaLiveMessagesContainer: HTMLElement): string {
        return [...$ariaLiveMessagesContainer.querySelectorAll<HTMLParagraphElement>('p, li')].reduce<string>(
            (totalMessage, $currentMessageElement) => {
                return totalMessage += `${$currentMessageElement.innerText} `;
            },
            ''
        );
    }
};
